const heatMapConfig = {
  credits: {
    enabled: false
  },

  exporting: { allowHTML: true, enabled: false },

  legend: {
    enabled: false
  },
  tooltip: {
    enabled: true,
    useHTML: true,
    padding: 0,
    formatter: function() {
      return `<div class="tooltip" style="background-color: rgba(247,247,247,0.85); border-radius: 3px; padding: 8px; position: relative; z-index: 999;"><b>${this.key}</b>: ${this.point.value}</div>`;
    },
  },
};

export default heatMapConfig;



// WEBPACK FOOTER //
// ./src/components/charts/chart-bar/ChartHeatMapConfig.js